export class AccountingDepartmentType {
    readonly name: string;
    readonly id: string;

    private constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }

    public static PERM = new AccountingDepartmentType(
        "A10000",
        "A10000 - Perm"
    );
    public static LOCUM = new AccountingDepartmentType(
        "A20000",
        "A20000 - Locum"
    );
    public static CONTRACT = new AccountingDepartmentType(
        "A30000",
        "A30000 - Contract"
    );
    public static MEMBERSHIP = new AccountingDepartmentType(
        "A40000",
        "A40000 - Membership"
    );
    public static JOB_POSTING = new AccountingDepartmentType(
        "A50000",
        "A50000 - Job Posting"
    );

    public static MARKETING = new AccountingDepartmentType(
        "6000",
        "6000 - Marketing"
    );
    public static asArray = () => [
        AccountingDepartmentType.PERM,
        AccountingDepartmentType.LOCUM,
        AccountingDepartmentType.CONTRACT,
        AccountingDepartmentType.MEMBERSHIP,
        AccountingDepartmentType.JOB_POSTING,
        AccountingDepartmentType.MARKETING,
    ];
}
